import "./App.css";
import MainForm from "./MainForm";
import MainBody from "./MainBody";
import MainFooter from "./MainFooter";
import { BrowserRouter } from "react-router-dom";
import OrderProvider from "./components/OrderProvider";

function App() {
  return (
    <>
      <BrowserRouter>
        <OrderProvider>
          <div className="main">
            <MainForm />
            <MainBody />
          </div>
          <MainFooter />
        </OrderProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
